export const ui_deviant_translations_german = {
    "Nuanced": "Komplex",
    "Logging in...": "Du wirst angemeldet... Falls du nach spätestens einer Minute nicht weitergeleitet wirst, schließe dieses Fenster und versuche dich erneut einzuloggen. Falls das Problem weiterhin auftritt, wende dich bitte an: psi-support@zdf.digital",
}

